<template lang="pug">
  v-dialog(
    :value="true"
    v-bind="dialogProps"
    persistent
    @click:outside="$modals.close()"
  ).scroll
    v-card.sdo-card
      v-list-item(v-if="title" style="min-height: 0 !important").pt-3.px-6.mb-0
        v-list-item-content.py-0
          h4.text-body-1: strong {{ title }}
        v-list-item-action.ma-0
          v-btn(
            fab
            text small
            @click.stop="$modals.close()"
          ): v-icon mdi-close
      v-sheet(flat max-height="75vh").overflow-y-auto.scroll
        v-card-text.pt-0
          .tex-body-2(
            v-if="message"
            v-html="message"
          )
          component(
            :is="component"
            v-bind="componentProps"
            v-on="componentProps"
          )

</template>

<script>
export default {
  props: {
    title: { type: String, default: null },
    message: { type: String, default: null },
    component: { type: [Object, String], default: null },
    componentProps: { type: Object, default: () => ({}) },

    dialogProps: {
      type: Object,
      default: () => ({
        width: 560,
      }),
    },
  },
};
</script>
